/**
 * Hostname -> tenant slug (D6 — synchronous, module-scope). Imports *only* `tenant-domains.json`
 * (TODO(infra): confirm the prod hosts below once DNS/CloudFront exist — mirrors the identical
 * placeholder in the backend registry) so the resolution chain has no edge to any consumer module
 * (§6.0/R6 of the plan): nothing that reads tenant state can be evaluated before this resolves.
 *
 * Do NOT import this module directly outside `@app/tenant`'s own `index.ts` — every other consumer
 * reads the already-resolved value from `@app/tenant`, never re-resolves it itself.
 */
import tenantDomains from './tenant-domains.json';

const domainToSlug: Record<string, string> = {};

Object.entries(tenantDomains as Record<string, string[]>).forEach(([slug, domains]) => {
  domains.forEach(domain => {
    domainToSlug[domain] = slug;
  });
});

export const resolveTenantSlug = (hostname: string): string | undefined => {
  const bySlug = domainToSlug[hostname];

  if (bySlug) {
    return bySlug;
  }

  // Dev-only fallback for plain `localhost`; second in precedence, never overrides a hostname
  // match, and inert in production builds (D6/D7 scope).
  if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_TENANT) {
    return process.env.REACT_APP_TENANT;
  }

  return undefined;
};

export const resolvedSlug = resolveTenantSlug(window.location.hostname);
